//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import showModal from "@/components/modal/index.vue";
import choiceScenic from "./choiceScenic.vue";
export default {
  data() {
    return {
      id: "",
      choiceScenic: {
        //景区的展示
        show: false
      },
      coverImagesUrl: "", //封面图
      title: "", //标题
      touristTags: [], //获取标签列表
      labelList: [], //标签列表
      scheduleList: [], //日程列表
      scenicList: [], //景区列表
      allScenicList: [], //全部景区
      content: "", //旅游故事
      list: [
        //描述列表
        {
          contents: "",
          imgs: [],
          showImgs: []
        }
      ],
      activeTagName: "半日游", //选中的标签名
      activeTagKey: 0, //选中的标签code
      scheduleName: "", //日程名称
      //弹框的展示与否
      modalSchedule: false, //日程
      modalTourist: false //标签
    };
  },
  components: {
    choiceScenic,
    showModal
  },
  async onLoad(event) {
    this.id = event.id;
    await this.getTouristTags(); //旅游标签的获取
    await this.getSchedule(); //旅游日程的获取
  },
  methods: {
    // 全部景区
    handleSuccess(datas) {
      if (datas.length) {
        this.scenicList = datas;
      }
      this.$refs.choiceScenic.selectList = this.$refs.choiceScenic.isSHowList
      this.choiceScenic.show = false;
    },
    getSpotList(item) {
      this.allScenicList = item[0].children;
      if (this.id) {
        this.queryData();
      }
    },
    //查询详情
    queryData() {
      this.$ajax({
        method: "post",
        url: "/weChat/cms/touriststrategy/queryById",
        data: {
          id: this.id
        }
      }).then(res => {
        this.coverImagesUrl = res.data.coverImagesUrl; //封面图
        this.title = res.data.title; //标题
        this.content = res.data.contents; //故事
        //日程
        let schedule = this.scheduleList.filter((t, i) => {
          if (t.key == res.data.severalDays) {
            return t;
          } else if (res.data.severalDays === "0.5") {
            return t;
          }
        });
        this.scheduleName = schedule[0].name;
        this.activeTagKey = schedule[0].key == "0.5" ? 0 : schedule[0].key;
        //景区
        let scenicspotIds = res.data.scenicspotIds.split(",");
        let arr = [];
        for (let i = 0; i < scenicspotIds.length; i++) {
          for (let j = 0; j < this.allScenicList.length; j++) {
            if (this.allScenicList[j].id === scenicspotIds[i]) {
              arr.push(this.allScenicList[j]);
            }
          }
        }
        this.scenicList = arr;
        this.scenicList.map(t=>{
          return t.isShow = true
        })
        this.handleSuccess(this.scenicList)
        //标签
        this.labelList = res.data.tag.map((t, i) => {
          return {
            code: t.key,
            name: t.value
          };
        });
        for (let i = 0; i < this.touristTags.length; i++) {
          for (let j = 0; j < this.labelList.length; j++) {
            if (this.labelList[j].code === this.touristTags[i].id) {
              this.touristTags[i].isShow = true
            }
          }
        }
        //照片描述
        this.list = JSON.parse(res.data.mainBody);
        this.list = this.list.map((t, i) => {
          return {
            contents: t.contents,
            imgs: t.imgs.split(","),
            showImgs: t.imgs.split(",")
          };
        });
      });
    },
    //旅游日程
    getSchedule() {
      this.$ajax({
        method: "post",
        url: "/weChat/dictionary/queryChildrenByParentCode",
        data: {
          code: "schedule"
        }
      }).then(res => {
        this.scheduleList = res.data.map((t, i) => {
          return {
            key: i,
            name: t.name
          };
        });
      });
    },
    //旅游标签
    getTouristTags() {
      this.$ajax({
        method: "post",
        url: "/weChat/cms/touriststrategy/getTouristTags",
        data: {}
      }).then(res => {
        this.touristTags = res.data.map(t => {
          return {
            isShow: false,
            ...t
          };
        });
      });
    },
    // 标题
    addTitle(e) {
      this.title = e.target.value;
    },
    //日程
    active(t) {
      this.activeTagKey = t.key;
      this.activeTagName = t.name;
    },
    showSchedule() {
      this.modalSchedule = true;
    },
    confirmSchedule() {
      this.scheduleName = this.activeTagName;
      this.modalSchedule = false;
    },
    // 删除景区
    close(item, i) {
      this.$refs.choiceScenic.handleCancel(item);
    },
    //标签
    activeLabel(t) {
      t.isShow = !t.isShow;
    },
    showTourist() {
      this.modalTourist = true;
    },
    confirmTourist() {
      this.modalTourist = false;
      this.labelList = this.touristTags.filter(t => {
        return t.isShow;
      });
    },
    //删除标签
    closeLabel(item, i) {
      this.labelList.splice(i, 1);
      this.touristTags.forEach(t => {
        if (t.id === item.id) {
          t.isShow = false;
        }
      });
    },
    //弹框的隐藏
    onCancel() {
      this.modalTourist = false;
      this.modalSchedule = false;
    },
    //旅游故事
    story(e) {
      this.content = e.target.value;
    },
    // 删除描述的一张图片
    remove(item, i) {
      item.imgs.splice(i, 1);
      item.showImgs.splice(i, 1);
    },
    //图片集的描述
    imgDescribe(event, t) {
      t.contents = event.target.value;
    },
    //新增描述
    addItem() {
      this.list.push({
        contents: "",
        imgs: [],
        showImgs: []
      });
    },
    //删除一个描述
    removeItem(i) {
      let _this = this;
      uni.showModal({
        content: "确定要删除该条数据吗？",
        success(res) {
          if (res.confirm) {
            _this.list.splice(i, 1);
          } else if (res.cancel) {
          }
        }
      });
    },
    // 新增图片 count 图片的数量限制 index 只用于当前页面 1 封面图 2 描述 item 当前的描述
    addImage(count, index, item) {
      let _this = this;
      uni.chooseImage({
        count: count, //默认9
        sizeType: ["original", "compressed"], //可以指定是原图还是压缩图，默认二者都有
        sourceType: ["album"], //从相册选择
        success: function(res) {
          let pics = []; //新的相册
          let data = []; //上传图片返回的值
          let usedCount = item ? item.showImgs.length : 0; //已上传的图片数量
          if (usedCount + res.tempFiles.length > count) {
            data = res.tempFilePaths.splice(0, count - usedCount);
          } else {
            data = res.tempFilePaths;
          }
          for (let i = 0; i < data.length; i++) {
            pics.push(data[i]);
          }
          _this.upImage(pics, index, item);
        }
      });
    },
    async upImage(files, index, item) {
      for (let i = 0; i < files.length; i++) {
        await this.upServer(files[i], index, item);
      }
    },
    upServer(file, index, item) {
      let _this = this;
      uni.uploadFile({
        url: _this.$store.state.proxyUrl + "/weChat/file/upload", //仅为示例，非真实的接口地址
        filePath: file,
        formData: {
          tenantId: _this.$store.state.tenantId
        },
        name: "files",
        success: uploadFileRes => {
          let url = JSON.parse(uploadFileRes.data).data[0].store;
          if (index === 1) {
            _this.coverImagesUrl = url;
          } else if (index === 2) {
            item.showImgs.push(url);
          }
        }
      });
    },
    //必填项提示
    formValidation() {
      let messages = "";
      let states = true;
      if (!this.coverImagesUrl) {
        messages = "请上传封面图片";
        states = false;
      } else if (!this.title) {
        messages = "请输入标题";
        states = false;
      } else if (!this.scheduleName) {
        messages = "请选择日程";
        states = false;
      } else if (this.scenicList.length === 0) {
        messages = "选择景区";
        states = false;
      } else if (!this.content) {
        messages = "请输入旅程故事";
        states = false;
      } else {
        this.list.forEach((t, i) => {
          if (states) {
            if (!t.contents) {
              messages = "第" + (i + 1) + "段照片描述不能为空";
              states = false;
              return;
            }
            if (t.showImgs.length === 0) {
              messages = "第" + (i + 1) + "段图片不能为空";
              states = false;
            }
          }
        });
      }
      if (!states) {
        uni.showToast({
          title: messages,
          icon: "none"
        });
      }
      return states;
    },
    // 攻略发布
    async submit() {
      let _this = this;
      //标签code
      let tags = this.labelList
        .map(t => {
          return t.code;
        })
        .join();
      //景区id
      let scenicspotIds = this.scenicList
        .map(t => {
          return t.id;
        })
        .join();
      if (this.formValidation()) {
        let obj = {
          coverImagesUrl: this.coverImagesUrl,
          title: this.title,
          severalDays: this.activeTagKey === 0 ? 0.5 : this.activeTagKey,
          userId: this.$store.state.userInfo.memberId,
          createName: this.$store.state.userInfo.nickName,
          imageUrl: this.$store.state.userInfo.headImage,
          mainBody: this.list,
          tags: tags,
          contents: this.content,
          scenicspotIds: scenicspotIds
        };
        if (obj.mainBody.length) {
          for (let i = 0; i < obj.mainBody.length; i++) {
            obj.mainBody[i].imgs = obj.mainBody[i].showImgs.join();
            delete obj.mainBody[i]["showImgs"];
          }
        }
        obj.mainBody = JSON.stringify(JSON.parse(JSON.stringify(obj.mainBody)));
        this.$ajax({
          method: "post",
          url: this.id?"/weChat/cms/touriststrategy/update":"/weChat/cms/touriststrategy/add",
          data: {
            ...obj,
			id:this.id?this.id:''
          }
        }).then(res => {
          uni.redirectTo({
            url: "/pages/strategy/success"
          });
        });
      }
    },
    cancel() {
      uni.showModal({
        title: "提示",
        content: "文件未保存，取消会丢失，确认取消吗？",
        success: function(res) {
          if (res.confirm) {
            uni.navigateTo({
              url: "/pages/strategy/index"
            });
          }
        }
      });
    }
  }
};
